<template>
  <div v-if="ready" class="weekly-hot">
    <div class="banner">
      <img :src="bannerImg" class="banner-img" />
    </div>
    <div class="outer-line">
      <div class="product-outer" v-for="(product, key) in products" :key="key">
        <product-block v-bind="{ info: product, gaEvent: '006' }">
          <div slot="rank" class="rank" :class="[`rank${product.sequence}`]">
            {{ product.sequence }}
          </div>
        </product-block>
      </div>
    </div>
  </div>
  <Spinner v-else bgc="#f6f6f6" />
</template>

<script>
import ProductBlock from '@/components/ProductBlock'
import Spinner from '@/components/shared/Spinner.vue'

export default {
  name: 'weeklyHot',
  components: {
    ProductBlock,
    Spinner,
  },
  data() {
    return {
      products: [],
      ready: false,
      bannerImg: ''
    }
  },
  computed: {},
  methods: {
    loadData: function() {
      const self = this
      api
        .getWeeklyHotProducts()
        .then(function(res) {
          // console.log('getWeeklyHotProducts:' + JSON.stringify(res.data));
          self.bannerImg = res.data.imagePath
          self.products = []
          // for (const i in res.data.dealList) {
          res.data.dealList.forEach((el, i) => {
            self.products.push({
              bid: el.bid,
              title: el.title,
              subTitle:
                el.specification == '' || el.specification == null
                  ? '單一規格'
                  : el.specification,
              imagePath: el.imagePath,
              soldOut: el.soldOut,
              originalPrice: el.originalPrice,
              price: el.price,
              sequence: el.sequence,
              paymentRestrict: el.paymentRestrict,
              promotion: el.promotion,
            })
          })
          self.ready = true
        })
        .catch(function(res) {
          console.log('getWeeklyHotProducts fail. ' + JSON.stringify(res))
        })
    },
    goProductPage(bid) {
      this.$router.push({ name: 'product', params: { id: bid } })
    },
  },
  mounted: function() {
    this.loadData()
  },
}
</script>

<style lang="scss" scoped>
.weekly-hot {
  background-color: #fff;

  .banner {
    padding: 10px 4.3% 16px;
  }
  .banner-img {
    width: 100%;
    object-fit: cover;
    display: block;
    border-radius: 8px;
  }
}

::v-deep.weekly-hot .outer-line {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4.3%;
  .product-outer {
    width: 50%;
    padding-bottom: 20px;
    &:nth-child(odd) {
      padding-right: 8px;
    }
    &:nth-child(even) {
      padding-left: 8px;
    }
  }
  .product-block {
    position: relative;
    height: 100%;
    .rank {
      position: absolute;
      top: 0px;
      width: 32px;
      height: 32px;
      object-fit: contain;
      z-index: 3;
      text-shadow: 0 1px 1px #b26339;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.7;
      text-align: center;
      color: #ffffff;
      background-image: url('../../assets/img/weeklyHot/rank-plain.svg');
      background-position: center;
      &.rank1 {
        width: 40px;
        line-height: 2.5;
        background-image: url('../../assets/img/weeklyHot/rank-1.svg');
      }
      &.rank2 {
        width: 40px;
        line-height: 2.5;
        background-image: url('../../assets/img/weeklyHot/rank-2.svg');
      }
      &.rank3 {
        width: 40px;
        line-height: 2.5;
        background-image: url('../../assets/img/weeklyHot/rank-3.svg');
      }
    }
    .originPrice {
      font-weight: lighter;
    }
    .buyBtn {
      width: 64px;
      height: 28px;
      border-radius: 4px;
      background-color: #1da7fc;
      color: white;
      font-size: 11px;
      font-weight: bold;
      line-height: 1.64;
      letter-spacing: normal;
      text-align: center;
      margin-bottom: auto;
    }
    @media (max-width: 374px) {
    }
  }
}
</style>
